import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { UserAvatar } from '@/components/UserAvatar';
import { useGetUserByIdQuery } from '@/features/user/userApi';

/**
 * A user as a small chip with their avatar and name, looked up by doc `id` (getUserById).
 * Until it loads, or for a user that no longer exists, the label is the id. showEmail shows
 * their email on hover. Other props go to the MUI Chip.
 */
export const UserChip = ({ id, showEmail = false, ...chipProps }) => {
	const { data: user } = useGetUserByIdQuery(id);
	return (
		// An empty title shows no tooltip
		<Tooltip title={(showEmail && user?.email) || ''} disableInteractive>
			<Chip
				size='small'
				label={user?.name ?? user?.email ?? id}
				avatar={<UserAvatar userId={id} />}
				{...chipProps}
			/>
		</Tooltip>
	);
};
